<!--
 * @Description: 
 * @Author: pcc
 * @Date: 2023-08-07 09:09:08
 * @LastEditors: pcc
 * @LastEditTime: 2023-10-17 18:19:46
-->
<template>
  <div class="print">
    <div class="title">厂商卡号验证</div>
    <div class="search">
      <el-form ref="formData" :inline="true" :model="formData">
        <div class="row">
          <el-form-item label="厂商编号:" prop="ma_Na">
            <el-input
              style="width: 4rem;"
              ref="input"
              v-model="formData.ma_Nu"
              placeholder="厂商编号"
              @keydown.enter.native="broadcast"
              @blur="onblur"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="background: #1890ff;color:#fff" :loading="loading" @click="broadcast">检查是否存在</el-button>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item>
            <el-checkbox v-model="formData.isLayers">启用厂商验证限制层数</el-checkbox>
          </el-form-item>
          <el-form-item label="层数编号:">
            <el-input placeholder="请输入楼层数" v-model="formData.layerNumber" />
          </el-form-item>
          <el-form-item>
            <el-button style="width:100px;" @click="saveConfig">确定</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getExhibitionCode, decryptingQRcode, checkManufacturer, decryptingHSQRcode } from '@/api/home'
import { mapState } from 'vuex'
import moment from 'moment'
var socketTimer = null
export default {
  data() {
    return {
      loading: false,
      isFocus: false,
      // 查询参数
      formData: {
        ma_Nu: '',
        isLayers: false,
        layerNumber: ''
      },
      exhibitionCode: '',
      path: 'ws://127.0.0.1:11999',
      socket: '',
      repeatCount: 2,
      searchType: '厂商编号查询',
      msg: ''
    }
  },
  computed: {
    ...mapState('tenant', ['tenantInfo'])
  },
  mounted() {
    this.initData()
    this.initSocket()
    this.$refs.input.focus()
  },
  destroyed() {
    this.socket = ''
    if (socketTimer) {
      clearInterval(socketTimer)
    }
  },
  methods: {
    // 初始化Socket
    initSocket() {
      if (typeof (WebSocket) === 'undefined') {
        this.$message.warning('您的浏览器不支持socket，将无法使用语音播报功能')
      } else {
        this.socket = new WebSocket(this.path)
        // 连接socket
        this.socket.onopen = () => { }

        // 连接错误
        this.socket.onerror = () => {
          const _this = this
          // 清楚socket心跳检测
          if (socketTimer) {
            clearInterval(socketTimer)
          }

          setTimeout(() => {
            _this.initSocket()
          }, 5000)
        }

        // 监听消息
        this.socket.onmessage = (res) => {
          if (res.data === 'ok') {
            if (this.repeatCount > 0) {
              this.speakText()
            }
          }
        }
      }
    },
    // socket心跳检测
    heartCheck() {
      if (socketTimer) {
        clearInterval(socketTimer)
      }

      const _this = this
      socketTimer = setInterval(() => {
        if (_this.socket.readyState !== 1) {
          _this.initSocket()
        }
      }, 3000)
    },

    initData() {
      getExhibitionCode().then(res => {
        if (res.success) {
          this.exhibitionCode = res.data || ''
        } else {
          this.$message.error(JSON.stringify(res.message))
        }
      })
      this.formData.isLayers = JSON.parse(localStorage.getItem('isLayers')) || false
      this.formData.layerNumber = localStorage.getItem('layerNumber') || ''
    },
    // 聚焦
    onblur() {
      if (!this.isFocus) {
        this.isFocus = true
        setTimeout(() => {
          this.isFocus = false
          this.searchType = '厂商编号查询'
          this.$refs.input.focus()
        }, 10000)
      }
    },
    // 发送语音播报
    speakText() {
      this.repeatCount--
      const speakMessage = this.msg
        .replaceAll('0', ' 0 ')
        .replaceAll('1', ' 1 ')
        .replaceAll('2', ' 2 ')
        .replaceAll('3', ' 3 ')
        .replaceAll('4', ' 4 ')
        .replaceAll('5', ' 5 ')
        .replaceAll('6', ' 6 ')
        .replaceAll('7', ' 7 ')
        .replaceAll('8', ' 8 ')
        .replaceAll('9', ' 9 ')
        .replaceAll('-', ' 杠 ')
        .replaceAll('_', ' 杠 ')

      const objData = {
        type: 2,
        message: speakMessage
      }
      this.socket.send(JSON.stringify(objData))
    },
    // 播报
    async broadcast() {
      this.repeatCount = 2

      // 校验厂商编号是否输入
      if (!this.formData.ma_Nu) {
        this.$message.warning('请选输入厂商编号')
        this.$refs.input.focus()
        return
      }

      // 大于20个字符(校验是否是小竹熊识别到的二维码)
      if (this.formData.ma_Nu.length > 20 && this.formData.ma_Nu.indexOf('hsrj') === -1) {
        const result = await decryptingQRcode({ code: decodeURIComponent(this.formData.ma_Nu) })
        if (result.success) {
          const strArr = result.data.split(';')
          // 判断展厅识别码
          if (this.exhibitionCode !== strArr[5]) {
            this.formData.ma_Nu = ''
            this.searchType = '厂商编号查询'
            this.msg = '请出示当前展厅的厂商二维码'
            this.speakText()
            this.$refs.input.focus()
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[1])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.formData.ma_Nu = ''
            this.searchType = '厂商编号查询'
            this.msg = '二维码已失效，请出示有效的二维码'
            this.speakText()
            this.$refs.input.focus()
            return
          }
          this.searchType = '小竹熊二维码查询'
          this.formData.ma_Nu = strArr[3]
        } else {
          this.formData.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          this.$refs.input.focus()
          return
        }
      }

      if (this.formData.ma_Nu.indexOf('hsrj') > -1) {
        const code = this.formData.ma_Nu.substring(this.formData.ma_Nu.indexOf('hsrj') + 4)
        const result = await decryptingHSQRcode({ code: code })
        if (result.success) {
          const strArr = result.data.split(',')
          // 判断展厅识别码
          if (this.tenantInfo.id != strArr[1]) {
            this.formData.ma_Nu = ''
            this.$message.error('该二维码不是当前展厅，请出示当前展厅的厂商二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[2])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.formData.ma_Nu = ''
            this.$message.error('二维码已失效，请出示有效的二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          this.formData.ma_Nu = strArr[0]
        } else {
          this.formData.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          this.$refs.input.focus()
          return
        }
      }

      // 获取厂商信息
      const mfrParam = {
        ma_Nu: this.formData.ma_Nu,
        isLayers: this.formData.isLayers,
        layerNumber: this.formData.layerNumber,
        source: this.searchType
      }

      const manufacturer = await checkManufacturer(mfrParam)
      if (manufacturer.success) {
        this.formData.ma_Nu = ''
        this.searchType = '厂商编号查询'
        this.msg = manufacturer.data.message
        this.speakText()
        this.$refs.input.focus()
      }

      this.formData.ma_Nu = ''
    },
    // 保存配置
    saveConfig() {
      localStorage.setItem('isLayers', String(this.formData.isLayers))
      localStorage.setItem('layerNumber', this.formData.layerNumber)
      this.$message.success('保存配置成功')
    }
  }
}
</script>
<style lang="scss" scoped>
.print {
  height: 100vh;
  font-family: MicrosoftYaHei;
  .title {
    text-align: center;
    padding: 0.2rem;
    font-size: 0.3rem;
    font-weight: bold;
    border: 0.01rem solid #eee;
  }

  .search {
    display: flex;
    align-items: center;
    min-height: 1.1rem;
    // height: 10%;
    padding: 0 0.3rem;

    .row {
      padding-top: 20px;
      margin-bottom: 30px;
      width: 100%;
      display: flex;
      align-items: center;
    }
    :deep .el-form-item {
      display: flex;
      align-items: center;
      margin: 0 0.2rem 0 0;

      .el-form-item {
        display: flex;
        align-items: center;
      }

      .el-form-item__label {
        font-size: 0.18rem !important;
        color: #222222;
      }

      .el-input__inner {
        font-size: 0.18rem !important;
        height: 0.4rem !important;
        line-height: 0.4rem !important;
        color: #8a8a8a;
      }
      button {
        height: 0.4rem !important;
        line-height: 0.4rem;
        padding: 0 0.06rem;
        font-size: 0.18rem !important;
        width: 1rem;
        color: #848484;
        width: 2rem;
      }
    }
  }
}
</style>